// extracted by css-extract-rspack-plugin
export default {"CardBase":"card-base-module__CardBase__pzDpG70"};